import {FeedbackContext, FeedbackType} from '../../models/Feedback';

export const buildFeedbackPayload = ({
    type,
    message,
    context,
}: {
    type: FeedbackType;
    message: string;
    context: FeedbackContext;
}) => {
    const body: Record<string, string> & {type: FeedbackType; message: string} = {type, message: message.trim()};
    if (context.relatedTraceId) body.relatedTraceId = context.relatedTraceId;
    if (context.currentPage) body.currentPage = context.currentPage.slice(0, 500);
    if (context.appVersion) body.appVersion = context.appVersion;
    if (context.technicalContext) body.technicalContext = context.technicalContext;

    return body;
};
